import { Directive, Injector, OnDestroy } from "@angular/core";
import { UntypedFormBuilder } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { Subject } from "rxjs";

import { environment } from "@env";
import { MaskService } from "@core/services/mask.service";
import { ModuleDetailsService } from "@core/services/module.details.service";
import { LocaleService } from "@core/services/locale.service";
import { NotifyService } from "@core/services";
import { AlertService } from "@core/services/alert.service";
import { MatDialog } from "@angular/material/dialog";
import { LoggerService, ModalWindowService } from "libs/core/src";

@Directive()
export class GenericComponent implements OnDestroy {
  readonly delay = environment.messageDelay;
  readonly paramId = "id";

  protected componentDestroyed$: Subject<any> = new Subject();

  /** Attributes */
  showLoading = true;
  pageSizeOptions = [5, 15, 30];
  defaultPageSize = 5;
  detailViewMinSize = 300;
  detailViewSize = 300;
  masterViewMinSize: number;
  modalResponse: string;
  useDialog = false;
  useResizeHandle = false;
  useSlideoverSidebarMode = false;

  /** Services */
  fb: UntypedFormBuilder;
  notify: NotifyService;
  route: ActivatedRoute;
  router: Router;
  localeService: LocaleService;
  translateService: TranslateService;
  moduleDetailsService: ModuleDetailsService;
  maskService: MaskService;
  loggerService: LoggerService;
  alertService: AlertService;
  modalWindowService: ModalWindowService;
  matDialog: MatDialog;

  constructor(injector: Injector) {
    this.fb = injector.get(UntypedFormBuilder);
    this.notify = injector.get(NotifyService);
    this.route = injector.get(ActivatedRoute);
    this.router = injector.get(Router);
    this.localeService = injector.get(LocaleService);
    this.translateService = injector.get(TranslateService);
    this.moduleDetailsService = injector.get(ModuleDetailsService);
    this.maskService = injector.get(MaskService);
    this.loggerService = injector.get(LoggerService);
    this.alertService = injector.get(AlertService);
    this.modalWindowService = injector.get(ModalWindowService);
    this.matDialog = injector.get(MatDialog);
  }

  closeTrigger = () => this.router.navigate(["."], { relativeTo: this.route });

  converterStringToJson(value: string): string {
    return JSON.stringify(value);
  }

  floatToMonetaryString(value: number): string {
    if (!value) {
      value = 0;
    }
    return value.toLocaleString("pt-BR", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  }

  monetaryStringToFloat(value: string): number {
    if (typeof value === "string") {
      value = value.split(".").join("");
      value = value.split(",").join(".");
      return parseFloat(value);
    }
    return parseFloat(value);
  }

  disableListSkeleton(): void {
    this.showLoading = false;
  }

  ngOnDestroy(): void {
    this.componentDestroyed$.next("");
    this.componentDestroyed$.complete();
  }

  redirectTo(url: string, queryParams?: any): void {
    this.router.navigate(["/" + url], { queryParams });
  }

  showSuccessMessage(data: any): void {
    let message: string = this.translateService.instant(
      "default-success-message"
    );

    if (data.message) {
      message = data.message;
    }
    this.notify.success(message, null, this.delay);
  }

  showErrorMessage(error: any, logMessage: string): void {
    this.loggerService.error(logMessage, error);

    let message: string = this.translateService.instant(
      "default-error-message"
    );
    if (error.error && error.error.message) {
      message = error.error.message;
    }
    this.notify.error(message, null, this.delay);
  }

  showValuesRBLADifferentsErrorMessage(error: any, logMessage: string): void {
    this.loggerService.error(logMessage, error);

    let message: string = this.translateService.instant(
      "default-values-rbla-error-message"
    );
    if (error.error && error.error.message) {
      message = error.error.message;
    }
    this.notify.error(message, null, this.delay);
  }
}
